var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-md relative"},[_c('textarea',{staticClass:"hidden"}),_vm._v(" "),(_vm.videoSwitch)?_c('VideoDialog',{on:{"closeVideo":_vm.closeVideo,"getLink":_vm.getLink}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }